import React from 'react'
import { Treasure } from '../../e.elements/GameElements/components'
import BasicBooty from '../../e.elements/scenes/SceneDemo/components/BasicBooty'
import onPointerDownHandler from '../TerrainManager/scripts/onPointerDownHandler'
import { addElementToGrid } from '../TerrainManager/scripts/scripts'
import { COMMANDERS, LevelConfig } from './store.d'

const Treasures = ({ levelConfig }: { levelConfig?: LevelConfig }) => {
  return (
    <>
      {levelConfig?.treasures.map(t => (
        <Treasure
          name={`treasure_${t.owner}`}
          key={`tresure_${t.owner}`}
          onStart={addElementToGrid}
          userData={{ coords: t.coords, args: t }}
          onPointerDown={onPointerDownHandler}
        >
          <BasicBooty color={t.owner === COMMANDERS.COM ? 0xff0000 : 0x00ff00} />
        </Treasure>
      ))}
    </>
  )
}

export default React.memo(Treasures)
